import { render, staticRenderFns } from "./HelpWithMyOrderNew.vue?vue&type=template&id=3fecad04&scoped=true"
import script from "./HelpWithMyOrderNew.vue?vue&type=script&lang=js"
export * from "./HelpWithMyOrderNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fecad04",
  null
  
)

export default component.exports